import { SingleCard } from '@liveauctioneers/hammer-ui-core/card/singleCard';
import { Carousel } from '@liveauctioneers/hammer-ui-core/carousel';

import { ItemPageItemCard } from '@/pages/Item/ItemPage/components/ItemPageItemCard/ItemPageItemCard';
import { useAppSelector } from '@/redux/hooks';
import { getArticleRelatedItemIds } from '@/redux/modules/articleRelatedItems/articleRelatedItems.selectors';
import { getItemSummaries } from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemCardSource, LotRecommendationType } from '@/utils/amplitude/analytics';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const ArticleRelatedItemsSection = ({ className }: { className?: string }) => {
    const itemIds = useAppSelector(getArticleRelatedItemIds);
    const itemSummaries = useAppSelector((state) => getItemSummaries(state, itemIds));
    const formatMessage = useAppFormatMessage();

    const cards = itemSummaries.map((item, index) => ({
        card: (
            <SingleCard
                card={ItemPageItemCard}
                className="h-[358px] w-[246px]"
                data={{
                    ...item,
                    itemCardSource: ItemCardSource.ArticlePage,
                    position: index,
                    recommendationType: LotRecommendationType.RelatedCategory,
                }}
            />
        ),
        key: `related-item-${item.itemId}`,
    }));

    if (cards.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            <Carousel
                useOverlayControls
                cards={cards}
                title={formatMessage(['itemPage', 'relatedItems'])}
            />
        </div>
    );
};
